/* ============================================================================
   ad-rc-setting-charge.js  —  DURABLE setting-charge for the Ring Configurator
   ----------------------------------------------------------------------------
   Why this exists: the configurator must add TWO cart lines (stone + the hidden
   "The Setting" variant) so the setting + metal is actually charged. That logic
   lives inside ad-ring-configurator.js, but that core file keeps getting
   overwritten by other automation, each time reverting to "charge the stone
   only" and silently dropping the setting price. This companion is loaded
   site-wide and, at runtime, REPLACES the Alpine component's addToCart with the
   correct two-line version. A core-file overwrite can no longer break checkout.
   Load DEFERRED, after Alpine. No em dashes.
   ============================================================================ */
(function () {
  'use strict';

  async function patchedAddToCart() {
    if (this.addingToCart || !this.selectedDiamond || !this.selectedDiamond.variantId) return;
    this.addingToCart = true;
    this.cartError = null;
    try {
      var d = this.selectedDiamond;
      var properties = {
        'Setting Style': (this.selectedSettingInfo && this.selectedSettingInfo.label) || '',
        'Metal':         (this.selectedMetalInfo && this.selectedMetalInfo.label) || '',
        'Ring Size':     this.sizeUnknown ? 'TBD - sized at consultation' : this.ringSizeLabel,
        'Diamond':       d.stoneId,
        'Shape':         d.shape,
        'Carat':         String(d.carat) + ' ct',
        'Color':         d.color,
        'Clarity':       d.clarity
      };
      if (this.finalTweaks && this.finalTweaks.trim()) properties['Final Adjustments'] = this.finalTweaks.trim();
      if (this.engravingText) { properties['Engraving'] = this.engravingText; properties['Engraving Font'] = this.engravingFont; }
      if (this.inspirationUrl) properties['Inspiration Reference'] = this.inspirationUrl;
      if (this.inspirationNotes && this.inspirationNotes.trim()) properties['Inspiration Notes'] = this.inspirationNotes.trim();

      var items = [{ id: parseInt(d.variantId, 10), quantity: 1, properties: properties }];

      /* Setting + metal ride as a real variant of the hidden "The Setting" product.
         Throw rather than add an underpriced cart. */
      if (this.selectedSetting && this.selectedMetal) {
        if (!window.AD_SettingVariants) {
          var sres = await fetch('/products/ad-ring-setting.js');
          if (sres.ok) {
            var sp = await sres.json();
            window.AD_SettingVariants = {};
            (sp.variants || []).forEach(function (v) { if (v.sku) { window.AD_SettingVariants[v.sku] = v.id; } });
          }
        }
        var skuKey = 'SET|' + this.selectedSetting + '|' + this.selectedMetal;
        var settingVid = window.AD_SettingVariants && window.AD_SettingVariants[skuKey];
        if (!settingVid) {
          throw new Error("We couldn't price your setting just now. Please refresh and try again, or contact us.");
        }
        items.push({
          id: settingVid,
          quantity: 1,
          properties: {
            'For Diamond': d.stoneId,
            'Ring Size':   this.sizeUnknown ? 'TBD - sized at consultation' : this.ringSizeLabel
          }
        });
      }

      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) {
        var eb = await res.json().catch(function () { return {}; });
        throw new Error(eb.description || eb.message || 'Cart add failed (' + res.status + ')');
      }
      window.location.href = '/cart';
    } catch (err) {
      console.error('[AD setting-charge] addToCart failed:', err);
      this.cartError = err.message || "Sorry, we couldn't add this to your cart. Please try again or contact us.";
      this.addingToCart = false;
    }
  }

  function patch() {
    var root = document.querySelector('[x-data^="adRingConfigurator"]');
    if (!root || !window.Alpine) return false;
    var d;
    try { d = Alpine.$data(root); } catch (e) { return false; }
    if (!d || typeof d.addToCart === 'undefined') return false;
    if (d.__adSettingChargePatched) return true;
    d.addToCart = patchedAddToCart;
    d.__adSettingChargePatched = true;
    return true;
  }

  document.addEventListener('alpine:initialized', patch);
  var tries = 0;
  var iv = setInterval(function () { if (patch() || ++tries > 80) clearInterval(iv); }, 250);
})();
